import { Box, CircularProgress, Typography } from '@mui/material';
import logo from '../images/logo_safedesk.png';

const Loading = () => (
    <Box
        sx={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f7fa',
            zIndex: 2000,
            gap: 3,
        }}
    >
        <Box
            component="img"
            src={logo}
            alt="SafeDesk"
            sx={{
                width: { xs: 200, sm: 280 },
                maxWidth: '80vw',
                height: 'auto',
                animation: 'safedesk-pulse 1.6s ease-in-out infinite',
                '@keyframes safedesk-pulse': {
                    '0%, 100%': { opacity: 1, transform: 'scale(1)' },
                    '50%': { opacity: 0.6, transform: 'scale(0.97)' },
                },
            }}
        />
        <CircularProgress size={36} thickness={4} />
        <Typography variant="body2" sx={{ color: 'text.secondary', letterSpacing: 1 }}>
            Carregando...
        </Typography>
    </Box>
);

export default Loading;

